import { render } from "./notice.vue?vue&type=template&id=aa3b1276"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/notice/notice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa3b1276"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa3b1276', __exports__)) {
    console.log('reload')
    api.reload('aa3b1276', __exports__)
  }
  
  module.hot.accept("./notice.vue?vue&type=template&id=aa3b1276", () => {
    console.log('re-render')
    api.rerender('aa3b1276', render)
  })

}


export default __exports__